module.exports = __webpack_public_path__ + "static/media/fujifilm.e77ab54e.png";